var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 10.5C9.38072 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38072 5.5 8.00001 5.5C6.6193 5.5 5.50001 6.61929 5.50001 8C5.50001 9.38071 6.6193 10.5 8.00001 10.5Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8C13.5 7.535 13.436 7.087 13.328 6.656L15.245 5.549L13.745 2.951L11.83 4.057C11.186 3.431 10.389 2.964 9.5 2.713V0.5H6.5V2.712C5.612 2.964 4.815 3.431 4.17 4.057L2.25501 2.951L0.755005 5.549L2.672 6.656C2.564 7.087 2.5 7.535 2.5 8C2.5 8.464 2.564 8.913 2.672 9.344L0.755005 10.451L2.25501 13.049L4.171 11.943C4.815 12.569 5.612 13.036 6.501 13.287V15.5H9.50101V13.288C10.39 13.036 11.186 12.569 11.831 11.944L13.747 13.05L15.247 10.452L13.33 9.345C13.436 8.913 13.5 8.464 13.5 8Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.5d4fc8f4d40ec316589156cab6ea2a55.svg";
export { ForwardRef as ReactComponent };